"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = void 0;
var React = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = __importDefault(require("./styles"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
var defaultProps = {
    as: 'div',
    span: {
        small: 4,
        medium: 12,
        large: 12
    },
    push: {},
    children: null,
    className: ''
};
// 👀 exporting as a const in addition to default to fix issue where Storybook loses descriptions and defaults
// eslint-disable-next-line import/export, no-redeclare
var Col = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var span = props.span, push = props.push, children = props.children, as = props.as, className = props.className, intrinsicElementProps = __rest(props, ["span", "push", "children", "as", "className"]);
    var As = as || defaultProps.as;
    var aggregateSpan = {
        small: (_a = span === null || span === void 0 ? void 0 : span.small) !== null && _a !== void 0 ? _a : defaultProps.span.small,
        medium: (_c = (_b = span === null || span === void 0 ? void 0 : span.medium) !== null && _b !== void 0 ? _b : span === null || span === void 0 ? void 0 : span.small) !== null && _c !== void 0 ? _c : defaultProps.span.medium,
        large: (_f = (_e = (_d = span === null || span === void 0 ? void 0 : span.large) !== null && _d !== void 0 ? _d : span === null || span === void 0 ? void 0 : span.medium) !== null && _e !== void 0 ? _e : span === null || span === void 0 ? void 0 : span.small) !== null && _f !== void 0 ? _f : defaultProps.span.large
    };
    var componentStyles = useStyles();
    var classes = (0, classnames_1.default)(componentStyles["span-sm-".concat(aggregateSpan.small)], componentStyles["span-md-".concat(aggregateSpan.medium)], componentStyles["span-lg-".concat(aggregateSpan.large)], (push === null || push === void 0 ? void 0 : push.small) != null && componentStyles["push-sm-".concat(push.small)], (push === null || push === void 0 ? void 0 : push.medium) != null && componentStyles["push-md-".concat(push.medium)], (push === null || push === void 0 ? void 0 : push.large) != null && componentStyles["push-lg-".concat(push.large)], className);
    return (React.createElement(As, __assign({ className: classes }, intrinsicElementProps), children));
};
exports.Col = Col;
exports.Col.displayName = 'Col';
// Added for Storybook documentation to display "default" for each prop
exports.Col.defaultProps = {
    as: 'div',
    children: null,
    push: defaultProps.push,
    span: defaultProps.span
};
